import AgnitioLogo from './logos/agnitio-logo.svg';
import AkuityLogo from './logos/akuity-logo.svg';
import AnourLogo from './logos/anour-logo.svg';
import BeyondUnityLogo from './logos/beyondunity-logo.svg';
import BlaBlaCarLogo from './logos/blablacar-logo.svg';
import BlinkLogo from './logos/blink-logo.svg';
import Blu5Logo from './logos/blu5labs-logo.svg';
import BmwLogo from './logos/bmw-logo.svg';
import BoschLogo from './logos/bosch-logo.svg';
import BrasswillowLogo from './logos/brasswillow-logo.svg';
import ChartipediaLogo from './logos/chartipedia-logo.svg';
import CorelLogo from './logos/corel-logo.svg';
import DahlerLogo from './logos/dahler-logo.svg';
import DtiqLogo from './logos/dtiq-logo.svg';
import ElephantTrunkLogo from './logos/elephantTrunk-logo.svg';
import ElmLogo from './logos/elm-logo.svg';
import EzycountLogo from './logos/ezycount-logo.svg';
import HolaspiritLogo from './logos/holaspirit-logo.svg';
import HolidaytaxisLogo from './logos/holidaytaxis-logo.svg';
import InterstatedataLogo from './logos/interstatedata-logo.svg';
import IonoviewLogo from './logos/ionoview-logo.svg';
import LamdenLogo from './logos/lamden-logo.svg';
import LeasewebLogo from './logos/leaseweb-logo.svg';
import MaxeonLogo from './logos/maxeon-logo.svg';
import NboxLogo from './logos/nbox-logo.svg';
import NetvicoLogo from './logos/netvico-logo.svg';
import NovolyzeLogo from './logos/novolyze-logo.svg';
import OliveTreeLogo from './logos/olivetree-logo.svg';
import ACNLogo from './logos/acn_logo.svg';
import PanoramLogo from './logos/panoram_logo.svg';
import CaidioLogo from './logos/caidio_logo.png';
import SystemLocoLogo from './logos/system_loco_logo.png';
import StriveeLogo from './logos/strivee_logo.svg';
import PolcoLogo from './logos/polco-logo.svg';
import PrismaLogo from './logos/prisma-logo.svg';
import PsoLogo from './logos/pso-logo.svg';
import ShowbizmodelsLogo from './logos/showbizmodels-logo.svg';
import SonnenLogo from './logos/sonnen-logo.svg';
import SpamonkeysLogo from './logos/spamonkeys-logo.svg';
import SuenaLogo from './logos/suena-logo.svg';
import TakamolLogo from './logos/takamol-logo.svg';
import TauronLogo from './logos/tauron-logo.svg';
import TeamAlertLogo from './logos/teamalert-logo.svg';
import TheworkroomLogo from './logos/theworkroom-logo.svg';
import TuiLogo from './logos/tui-logo.svg';
import UndpLogo from './logos/undp-logo.svg';
import VinersLogo from './logos/viners-logo.svg';
import VirginRadioLogo from './logos/virginradio-logo.svg';
import YoucatLogo from './logos/youcat-logo.svg';
import DecathlonLogo from '../../assets/images/design-that-tells-stories/decathlon_logo.svg';
import HumanitasLogo from './logos/humanitas-logo.svg';
import MaxioLogo from './logos/maxio_logo.png';
import PlanetEscapeLogo from './logos/planet_escape_logo.png';
import ElfLogo from './logos/elf_logo.png';
import ResidentPropertyLogo from './logos/resident_property_logo.png';
import OcchioLogo from './logos/occhio-logo.png'
import NidecLogo from './logos/nidec-logo.png'

export const CLIENTS = [
  {
    name: 'Decathlon',
    photo: DecathlonLogo,
    url: 'https://www.decathlon.com/',
    description:
      'Boldare’s team contributed to the product development of one of the digital products of Decathlon, the renowned French multinational established in 1976 that designs, manufactures and retails sports goods, aimed at enhancing online sales numbers.',
  },
  {
    name: 'BlaBlaCar',
    photo: BlaBlaCarLogo,
    url: 'https://www.blablacar.com/',
    description:
      'Boldare’s team joined the crew behind BlaBlaCar, the world’s leading community-based travel app, as their strategic digital partner, working on the mission to be the go-to marketplace for shared transportation.',
  },
  {
    name: 'UNDP',
    photo: UndpLogo,
    url: 'https://www.undp.org/',
    description:
      'Boldare’s team built a system for clear, efficient data representation for UNDP, a United Nations agency operating in 170 nations fighting poverty & inequality, aiding their mission’s analysis capabilities.',
  },
  {
    name: 'BOSCH',
    photo: BoschLogo,
    url: 'https://www.bosch.com/',
    description:
      'Boldare’s team develops and maintains the warranty system for the BOSCH power tools that help build our homes, schools and hospitals — the strategic digital project at the heart of our long-term partnership.',
  },
  {
    name: 'TUI',
    photo: TuiLogo,
    url: 'https://www.tui.com/',
    description:
      'Boldare’s team partnered with TUI Musement, a global leader in local tours operating in 80 countries worldwide, to enter a new market segment and enrich travel experiences.',
  },
  {
    name: 'Corel',
    photo: CorelLogo,
    url: 'https://www.corel.com/',
    description:
      'Boldare’s team worked on the development and rapid growth of the core products of Corel, the Canadian software giant whose graphic processing solutions are used by millions around the world daily.',
  },
  {
    name: 'Sonnen',
    photo: SonnenLogo,
    url: 'https://sonnen.de/',
    description:
      'Boldare’s team is a strategic long-term partner to sonnen, a rockstar in the solar energy industry, helping make tangible change in the world and take us a step closer to a clean, green energy-powered world.',
  },
  {
    name: 'Maxeon',
    photo: MaxeonLogo,
    url: 'https://www.maxeon.com/',
    description:
      'Boldare’s team consulted on and developed top-notch solutions for the customers of Maxeon, a global solar innovation leader with 1000+ patents serving customers in over 100 countries.',
  },
  {
    name: 'Leaseweb',
    photo: LeasewebLogo,
    url: 'https://www.leaseweb.com/',
    description:
      'Boldare’s team has supported the tremendous growth of Leaseweb, a leading infrastructure-as-a-service provider with data centers in Europe, the United States and Asia, working on more than a dozen products since 2008.',
  },
  {
    name: 'PRISMA',
    photo: PrismaLogo,
    url: 'https://www.prisma-platform.eu/',
    description:
      'Boldare’s team is a long-term partner to PRISMA, a leading European gas trading platform, supporting its mission to secure Europe’s energy supply and enable a green transition for a sustainable future.',
  },
  {
    name: 'Takamol',
    photo: TakamolLogo,
    url: 'https://www.takamol.com.sa/',
    description:
      'Boldare’s team develops web products that drive true change in the Saudi labor market as strategic digital partner to Takamol Holding, a Saudi Arabian government company.',
  },
  {
    name: 'Elm',
    photo: ElmLogo,
    url: 'https://www.elm.sa/',
    description:
      'Boldare’s team builds solutions for both public and private sectors as strategic digital partner to Elm, the leading provider of innovative secure services & solutions in Saudi Arabia.',
  },
  {
    name: 'ACN',
    photo: ACNLogo,
    url: 'https://acn-canada.org/',
    description:
      'Boldare’s team designed the website for ACN, founded in 1947 as a Catholic aid organization dedicated to serving persecuted Christians globally through information, prayer and action, supporting thousands of projects annually through private donations.',
  },
  {
    name: 'Panoram',
    photo: PanoramLogo,
    url: 'https://panoram.io/',
    description:
      'Boldare’s team provides DevOps support and team augmentation services to Panoram, which accelerates the legal industry’s digital transformation through strategic planning, technology engineering and managed services, enhancing their operational capabilities.',
  },
  {
    name: 'Caidio',
    photo: CaidioLogo,
    url: 'https://caidio.com/',
    description:
      'Boldare’s team played a pivotal role by rewriting the software that collects data from the hardware solution of Caidio, which develops data-driven technologies to enhance the quality and productivity of global concrete construction.',
  },
  {
    name: 'System Loco',
    photo: SystemLocoLogo,
    url: 'https://systemloco.com/',
    description:
      'Boldare’s team is implementing new front-end designs to improve the user experience, efficiency and scalability of an application for System Loco, which provides high-performance sensing and location capabilities and low-power functionality for IoT systems.',
  },
  {
    name: 'Strivee',
    photo: StriveeLogo,
    url: 'https://strivee.com/',
    description:
      'Boldare’s team optimized the chat feature and front end of the mobile app of Strivee, the French market leader offering software for coaches and gym owners to manage training, track athlete progress and drive business development, to improve user experience.',
  },
  {
    name: 'POLCO',
    photo: PolcoLogo,
    url: 'https://polco.us/',
    description:
      'POLCO is politics without the noise: an app for real-time citizen polling and validated analytics. They are responsible for creating democracy and letting people take part in political life.',
  },
  {
    name: 'Dahler',
    photo: DahlerLogo,
    url: 'https://dahler.com/',
    description:
      'Boldare’s team brought software development expertise to Dahler, a luxury real estate franchise company that makes it easy to manage properties — expertise that, coupled with their industry knowledge, resulted in new growth.',
  },
  {
    name: 'Tauron Polska Energia',
    photo: TauronLogo,
    url: 'https://www.tauron.pl/',
    description:
      'Boldare’s team is focused on integrating the vast IT architecture of Tauron, the second-largest energy company in Poland that provides power to half of the country, as their strategic digital partner.',
  },
  {
    name: 'Suena',
    photo: SuenaLogo,
    url: 'https://suena.com/',
    description:
      'Boldare’s team created the MVP for Suena, a powerful German startup revolutionizing energy storage and integrating AI-fueled power trading — an MVP built for an expo that helped them raise 1.2 million euros.',
  },
  {
    name: 'HolidayTaxis',
    photo: HolidaytaxisLogo,
    url: 'https://www.holidaytaxis.com/',
    description:
      'Boldare’s team supported the rapid growth of HolidayTaxis with technology expertise, taking an agile approach to digital product development that helped streamline their global airport-hotel transfers.',
  },
  {
    name: 'Lamden',
    photo: LamdenLogo,
    url: 'https://lamden.io/',
    description:
      'Boldare’s team designed and developed the company website for Lamden, a pioneering blockchain platform, enhancing their professional image in the cryptocurrency space.',
  },
  {
    name: 'EZYCount',
    photo: EzycountLogo,
    url: 'https://ezycount.ch/',
    description:
      'Boldare’s team developed a web app for EZYcount, a Switzerland-based accounting solution, supporting their mission to make life easier for Swiss businesses and the self-employed.',
  },
  {
    name: 'Novolyze',
    photo: NovolyzeLogo,
    url: 'https://novolyze.com/',
    description:
      'Boldare’s team delivered full cycle product development for Novolyze, a US food safety and quality innovator, improving food safety and sustainability and helping to make everyday life healthier.',
  },
  {
    name: 'Akuity',
    photo: AkuityLogo,
    url: 'https://akuity.com/',
    description:
      'Boldare’s team created a new website for Akuity, a cloud application deployment firm providing services and SaaS, showcasing their services and positioning them as a top player.',
  },
  {
    name: 'Agnitio',
    photo: AgnitioLogo,
    url: 'https://agnitio.com/',
    description:
      'Boldare’s team developed innovative customer engagement solutions for pharma and medical companies together with Agnitio, a top-tier life sciences-focused software company, working with their team at the Danish HQ.',
  },
  {
    name: 'Blink',
    photo: BlinkLogo,
    url: 'https://blink.com/',
    description:
      'Boldare’s team created an all-in-one platform to streamline supply chains for Blink, the industry-leading digital platform for trading construction materials.',
  },
  {
    name: 'Virgin Radio Oman',
    photo: VirginRadioLogo,
    url: 'https://virginradiooman.com/',
    description:
      'Boldare’s team designed and developed a website, live-streaming app and mobile app for SABCO Media, Oman’s leading media provider, powering Virgin Radio’s digital debut in the region.',
  },
  {
    name: 'Blu5 Labs',
    photo: Blu5Logo,
    url: 'https://blu5labs.com/',
    description:
      'Boldare’s team augmented the in-house digital teams of Blu5 Labs, a telecom security leader, on a mission to help them minimize attack surfaces while fortifying core operations.',
  },
  {
    name: 'ANOUR',
    photo: AnourLogo,
    url: 'https://anour.dk/',
    description:
      'Boldare’s team works on expanding the market share of ANOUR, a renowned Copenhagen-based lamp manufacturer, in the UK and Scandinavia, supporting their vision for expansion.',
  },
  {
    name: 'DTIQ',
    photo: DtiqLogo,
    url: 'https://dtiq.com/',
    description:
      'Boldare’s team refined the product development of DTiQ, a world-leading provider of intelligent surveillance and loss prevention, driving continuous innovation and enabling further growth.',
  },
  {
    name: 'Viners',
    photo: VinersLogo,
    url: 'https://viners.co.uk/',
    description:
      'Boldare’s team bridged the gap between the classic UK cutlery range of Viners, a leading British brand and cutler, and their new online customers.',
  },
  {
    name: 'Youcat',
    photo: YoucatLogo,
    url: 'https://youcat.org/',
    description:
      'Boldare’s team supports the YOUCAT Foundation in its transition to the digital age, helping it inspire young Catholics by enabling them to learn about and share their faith.',
  },
  {
    name: 'Netvico',
    photo: NetvicoLogo,
    url: 'https://netvico.com/',
    description:
      'Boldare’s team works on the SaaS development software of Netvico, a German company offering interactive digital signage solutions, helping their B2B customers manage marketing campaigns in a long-term partnership.',
  },
  {
    name: 'Polskie Składy Oponiarskie',
    photo: PsoLogo,
    url: 'https://psopony.pl/',
    description:
      'Boldare’s team helped drive the growth of Polskie Składy Oponiarskie, which brings together the top Polish tire distributors, through the design and development of their products, making sure drivers stay safe.',
  },
  {
    name: 'Holaspirit',
    photo: HolaspiritLogo,
    url: 'https://holaspirit.com/',
    description:
      'Boldare’s team created the platform for Holaspirit, a company supporting self-organized teams — together we have empowered businesses to enhance the employee experience.',
  },
  {
    name: 'SpaMonkey',
    photo: SpamonkeysLogo,
    url: 'https://spamonkey.com/',
    description:
      'Boldare’s team developed an e-commerce platform for SpaMonkey, a Hong Kong-based retailer of organic beauty products, improving their online presence and sales process.',
  },
  {
    name: 'TeamAlert',
    photo: TeamAlertLogo,
    url: 'https://teamalert.com/',
    description:
      'Boldare’s team improved the app of TeamAlert, a US innovator in emergency alert systems whose products protect the safety of real people around the globe and alert first responders.',
  },
  {
    name: 'Brass Willow',
    photo: BrasswillowLogo,
    url: 'https://brasswillow.com/',
    description:
      'Boldare’s team worked with Brass Willow, an agile consulting company run by Scrum experts who took part in the creation of Scrum.org, on streamlining and increasing their revenue.',
  },
  {
    name: 'Showbiz Models Agency',
    photo: ShowbizmodelsLogo,
    url: 'https://showbizmodelsagency.com/',
    description:
      'Boldare’s team created and developed new flagship software to replace a legacy app for Showbiz Models Agency, a leading recruitment agency for models and hostesses in Italy.',
  },
  {
    name: 'The Workroom',
    photo: TheworkroomLogo,
    url: 'https://theworkroom.com/',
    description:
      'Boldare’s team built a mobile app for The Workroom, a London-based venture offering on-demand workspaces in luxury restaurants, expanding their reach in the coworking market.',
  },
  {
    name: 'Interstate Data',
    photo: InterstatedataLogo,
    url: 'https://interstatedata.com/',
    description:
      'Boldare’s team delivered the full cycle development of a revolutionary iOS app for Interstate Data, a mobile navigation provider, fostering a mobile change.',
  },
  {
    name: 'Chartipedia',
    photo: ChartipediaLogo,
    url: 'https://chartipedia.com/',
    description:
      'Boldare’s team developed the MVP app for Chartipedia, validating their vision for a global chart community and paving the way for a "Wiki for visual data".',
  },
  {
    name: 'BMW Smorawiński',
    photo: BmwLogo,
    url: 'https://bmwsmorawinski.pl/',
    description:
      'Boldare’s partnership with BMW Smorawiński, Poland’s largest car dealership with a professional service center and a parts and accessories department, made car buying and maintenance more efficient.',
  },
  {
    name: 'BeyondUnity',
    photo: BeyondUnityLogo,
    url: 'https://beyondunity.com/',
    description:
      'Boldare’s team supports Beyond Unity, an award-winning global consulting firm shaping leaders’ impact, through innovative application development as their strategic technology partner.',
  },
  {
    name: 'Iono View',
    photo: IonoviewLogo,
    url: 'https://ionoview.com/',
    description:
      'Iono View is the smart residential and commercial cleaning services solution in the MENA region, committed to supporting companies that keep living & working spaces clean and safe to be in.',
  },
  {
    name: 'Nbox',
    photo: NboxLogo,
    url: 'https://nbox.com/',
    description:
      'Boldare’s team delivers innovative solutions that enhance the mail services of NBox, supporting their mission of providing convenient delivery, pickup and virtual options.',
  },
  {
    name: 'Olive Tree Holdings',
    photo: OliveTreeLogo,
    url: 'https://olivetreeventures.com/',
    description:
      'Boldare’s team built TrueRate Services for Olive Tree Ventures, an American business, developing an MVP that contributed to a 60% monthly traffic increase and over $100M in loan closures.',
  },
  {
    name: 'Elephant Trunk',
    photo: ElephantTrunkLogo,
    url: 'https://theelephantstrunk.com/',
    description:
      'Boldare’s team built custom, personalized book creation software for The Elephant’s Trunk, an Irish publisher on a mission to make inclusive stories that portray a diverse range of children.',
  },
  {
    name: 'Maxio',
    photo: MaxioLogo,
    url: 'https://maxio.com/',
    description:
      'Boldare’s team supported Maxio with specialized experts proficient in 5 programming languages, backing up their own teams. Maxio helps SaaS businesses uncover the financial insights they need to run an efficient SaaS business today.',
  },
  {
    name: 'Planet Escape',
    photo: PlanetEscapeLogo,
    url: 'https://planetescape.com/',
    description:
      'Boldare’s team helped Planet Escape, a boutique travel agency specializing in roads less travelled and menus a la carte, define new directions for the company’s development, providing a research and strategy workshop as well as a detailed website audit.',
  },
  {
    name: 'Humanitas',
    photo: HumanitasLogo,
    url: 'https://humanitas.edu/',
    description:
      'Boldare’s team prepared a website project for the Humanitas Academy, primarily aimed at selling services such as undergraduate and postgraduate studies and MBA programs, supporting its mission to build a strong academic center in the region.',
  },
  {
    name: 'Elf',
    photo: ElfLogo,
    url: 'https://www.elfcosmetics.com/',
    description:
      'Boldare’s team supports the development of the eCommerce platform of e.l.f. Beauty, a globally recognized beauty company founded in 2004 known for innovative, prestige quality, cruelty-free products at an incredible value in 15 countries, to enhance its digital performance.',
  },
  {
    name: 'Resident Property',
    photo: ResidentPropertyLogo,
    url: 'https://residentproperty.com/',
    description:
      'Boldare’s team supports the evolution of the platform of Resident Property, founded in 2014 and a UK-based leader in block management software that helps clients save time and money and stay compliant, to enhance its digital capabilities.',
  },

  {
    name: 'Occhio GmbH',
    photo: OcchioLogo,
    url: 'https://www.occhio.com/',
    description:
      'Occhio revolutionized lighting with designs offering optimal solutions for any space. Known for exceptional quality, it enables users to design with light in both private and commercial sectors. Today, Occhio is a fast-growing luxury brand with over 250 employees and flagship stores in Munich, Milan, London, and Shanghai.',
  },

  {
    name: 'Nidec',
    photo: NidecLogo,
    url: 'https://www.nidec.com/en/',
    description:
      'Nidec Conversion, part of Nidec Corporation, provides energy-efficient electrical systems. With 2,000+ employees across 10 countries, it specializes in customized solutions for energy, steel, petrochemical, and automation industries. The company focuses on clean energy, energy storage, and e-mobility for a sustainable future.',
  },
];
